import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AuthService } from '../../share/services/auth.service';

@Component({
  selector: 'app-login',
  imports: [CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  constructor(
    private authService: AuthService
  ) {}

  public getLoginDisplay(): boolean {
    return this.authService.loginDisplay;
  }

  public loginPopup() {
    this.authService.loginPopup();
  }

  public logout(popup: boolean) {
    this.authService.logOut(popup);
  }

}
